module.exports = __webpack_public_path__ + "img/avigilon_logo_svg.05890feb.svg";